import React from 'react'
import { createLocalizedPath } from '../../../utils/localizationHelpers'
import paths from '../../../paths'
import './avatarLink.sass'
import { Link } from 'react-router-dom'

interface Props {
    img?: string
    nick?: string
    isLoading?: boolean
}

const AvatarLink: React.FunctionComponent<Props> = ({ img, nick, isLoading = false }: Props) => {
    return (
        <div className="avatar_link">
            {isLoading ? (
                <img className={'skeleton'} />
            ) : (
                <Link to={createLocalizedPath(paths.profile.toPath({ nick: nick }))}>
                    <img src={img} alt="" />
                </Link>
            )}
        </div>
    )
}

export default AvatarLink
